import { useEffect } from 'react';
import { useCountdown } from 'usehooks-ts';

import { UnboaredLight } from './UnboaredLight';
import styles from './UnboaredSpinner.module.css';

const SIZE_LOADER = 100;
const STROKE_WIDTH = 0.12 * SIZE_LOADER;
const SPEED_LOADER = 2.3;
const INTERVAL_VALUE = 30;

export function UnboaredSpinner() {
    const [count, { startCountdown, stopCountdown }] = useCountdown({
        countStart: 100000,
        intervalMs: INTERVAL_VALUE,
    });

    useEffect(() => {
        startCountdown();
        return stopCountdown;
    }, []);

    const YellowLightSVG = (
        <UnboaredLight angle={SPEED_LOADER * count} color="#f3ca20" size={SIZE_LOADER} strokeWidth={STROKE_WIDTH} />
    );
    const RedLightSVG = (
        <UnboaredLight angle={-SPEED_LOADER * count} color="#FF2354" size={SIZE_LOADER} strokeWidth={STROKE_WIDTH} />
    );

    return (
        <div className={styles.container} style={{ width: SIZE_LOADER, height: SIZE_LOADER }}>
            <div className={styles.absolute}>{YellowLightSVG}</div>
            <div className={styles.absolute}>{RedLightSVG}</div>
        </div>
    );
}
